import Animated, { type SharedValue, useAnimatedStyle } from "react-native-reanimated";
import { type StackProps, XStack, YStack } from "@medbillai/ui";
const ProgressBar = Animated.createAnimatedComponent(XStack);
interface HeaderProgressBarPropsLargeOutline {
  animatedProgress: SharedValue<number>;
  backgroundColor?: StackProps["backgroundColor"];
  height?: StackProps["height"];
  borderRadius?: StackProps["borderRadius"];
}

/**
 * This should be used with the useHeaderProgressBar hook. This can be used
 * in any layout.web.tsx file.
 *
 * Most styling taken from HeaderProgressBar.tsx
 */
export const HeaderProgressBarLargeOutline = ({
  animatedProgress,
  backgroundColor = "$backgroundTertiary",
  height = "$0.75",
  borderRadius = "$0"
}: HeaderProgressBarPropsLargeOutline) => {
  // Animated style applies smoothly without breaking on rerenders
  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{
      scaleX: animatedProgress.value
    }]
  }), [animatedProgress]);
  return <YStack position="absolute" left={0} right={0} top={0} zIndex={1000} width="100%" justifyContent="center" alignItems="center" data-sentry-element="YStack" data-sentry-component="HeaderProgressBarLargeOutline" data-sentry-source-file="HeaderProgressBarLargeOutline.tsx">
      <XStack height={height} backgroundColor={backgroundColor} width="100%" overflow="hidden" borderRadius={borderRadius} data-sentry-element="XStack" data-sentry-source-file="HeaderProgressBarLargeOutline.tsx">
        <ProgressBar height={height} overflow="hidden" backgroundColor="$navy" transformOrigin="left center" width="100%" style={animatedStyle} borderRadius={borderRadius} data-sentry-element="ProgressBar" data-sentry-source-file="HeaderProgressBarLargeOutline.tsx" />
      </XStack>
    </YStack>;
};